module.exports = __webpack_public_path__ + "static/cr-fdb730f2edcd8f4bdc2752ab73fee531.svg";